import React from 'react'

const LoginFooter = () => {
    const year = new Date().getFullYear()

  return (
    <footer className="absolute bottom-3 text-white font-normal text-sm w-full text-center px-4">
      <div className="mb-1">
        contato@rioclaro.com.br | +55 (61) 3044-7780
      </div>
      <div>
        <span className="font-semibold">© {year} Rio Claro</span> |
        CNPJ: 31.249.802/0001-63 |
        <a href="https://app.rioclaro.com.br/termos-de-uso" className="text-tealSoft hover:opacity-80 mx-1 underline">Termos de uso</a> |
        Desenvolvido pela <a
          href="https://www.humanoide.dev/"
          className="text-tealSoft hover:opacity-80 ml-1 underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          Humanoide.dev
        </a>
      </div>
    </footer>
  )
}

export default LoginFooter
